import React, { useEffect, useState } from 'react';
import { useAuth } from '@clerk/clerk-react';
import axiosInstance, { coreBackendAxios } from '../../Store/axiosInterceptor';

const ClerkAxiosInterceptor: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { getToken } = useAuth();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Interceptor for the main gateway instance
    const requestInterceptor = axiosInstance.interceptors.request.use(
      async (config: any) => {
        try {
          const token = await getToken();
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
          }
        } catch (error) {
          console.error("Failed to get Clerk token", error);
        }
        return config;
      },
      (error: any) => Promise.reject(error)
    );

    // Interceptor for the core backend instance
    const coreInterceptor = coreBackendAxios.interceptors.request.use(
      async (config: any) => {
        try {
          const token = await getToken();
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
          }
        } catch (error) {
          console.error("Failed to get Clerk token", error);
        }
        return config;
      },
      (error: any) => Promise.reject(error)
    );

    setIsReady(true);

    return () => {
      axiosInstance.interceptors.request.eject(requestInterceptor);
      coreBackendAxios.interceptors.request.eject(coreInterceptor);
    };
  }, [getToken]);

  if (!isReady) {
    return null; // Wait until interceptors are securely mounted
  }

  return <>{children}</>;
};

export default ClerkAxiosInterceptor;
